import { Button, Spinner } from '@crm/ui';
import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { FormError, FormField, FormSuccess } from '@/components';
import { useChangePassword } from '@/modules/auth/hooks';
import { type ChangePasswordFormValues, changePasswordSchema } from '@/modules/auth/schemas';
import { toErrorMessage } from '@/modules/auth/utils';

interface ChangePasswordFormProps {
  /** Quando a modal e quem manda salvar, o botao daqui sai de cena. */
  formId?: string;
  hideSubmit?: boolean;
  onChanged?: () => void;
}

/** Alteracao da propria senha (exige a senha atual). */
export function ChangePasswordForm({ formId, hideSubmit, onChanged }: ChangePasswordFormProps) {
  const changePassword = useChangePassword();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<ChangePasswordFormValues>({
    resolver: zodResolver(changePasswordSchema),
    defaultValues: { currentPassword: '', newPassword: '', confirmPassword: '' },
  });

  return (
    <form
      id={formId}
      className="space-y-4"
      onSubmit={handleSubmit((values) =>
        changePassword.mutate(values, {
          onSuccess: () => {
            reset();
            onChanged?.();
          },
        }),
      )}
      noValidate
    >
      <FormError message={changePassword.error ? toErrorMessage(changePassword.error) : null} />

      {changePassword.isSuccess ? (
        <FormSuccess message="Senha alterada. As outras sessoes foram encerradas." />
      ) : null}

      <FormField
        label="Senha atual"
        type="password"
        autoComplete="current-password"
        error={errors.currentPassword?.message}
        {...register('currentPassword')}
      />

      <FormField
        label="Nova senha"
        type="password"
        autoComplete="new-password"
        error={errors.newPassword?.message}
        {...register('newPassword')}
      />

      <FormField
        label="Confirmar nova senha"
        type="password"
        autoComplete="new-password"
        error={errors.confirmPassword?.message}
        {...register('confirmPassword')}
      />

      {hideSubmit ? null : (
        <Button type="submit" disabled={changePassword.isPending}>
          {changePassword.isPending ? <Spinner /> : null}
          Alterar senha
        </Button>
      )}
    </form>
  );
}
